module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "ui stackable three column grid"
  }, _vm._l((_vm.channels), function(channel) {
    return _c('div', {
      staticClass: "fb-page",
      attrs: {
        "data-href": channel.url,
        "data-tabs": "timeline",
        "data-small-header": "true",
        "data-adapt-container-width": "false",
        "data-hide-cover": "false",
        "data-show-facepile": "false"
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "ui stackable two column grid"
  }, _vm._l((_vm.facebooks), function(facebook) {
    return _c('div', [_c('div', {
      staticClass: "column fb-post",
      attrs: {
        "data-href": facebook.url,
        "data-show-text": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fb-comments",
      attrs: {
        "data-href": facebook.url,
        "data-numposts": "5"
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18175d38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Facebook.vue
// module id = 49
// module chunks = 1 2